import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const IntegrationsService = {
    create: async (model) => axios.post(API_URL + "/integrations", model).then(({data}) => data).catch(err => { throw err }),
    edit: async (model, id) => axios.post(API_URL + "/integrations/" + id, model).then(({data}) => data).catch(err => { throw err }),
    delete: async (id) => axios.delete(API_URL + "/integrations/" + id).then(({data}) => data).catch(err => { throw err }),
    deleteAssociatedIntegration: async (id) => axios.delete(API_URL + "/associatedIntegrations/" + id).then(({data}) => data).catch(err => { throw err }),
    list: async (filters) => axios.post(API_URL + "/integrations/list", filters).then(({data}) => data).catch(err => { throw err }),
    listRequests: async (id, type) => axios.post(API_URL + "/integrations/list/requests/" + id + "/" + type).then(({data}) => data).catch(err => { throw err }),
    getById: async (id) => axios.get(API_URL + "/integrations/" + id).then(({data}) => data).catch((err) => { throw err }),
    getIntegrations: async () => axios.get(API_URL + "/integrations/ids/related").then(({data}) => data).catch((err) => { throw err }),
}

export default IntegrationsService;